<script setup>
import {computed} from 'vue';
import {useStore} from "vuex";

const store = useStore();
const getUrl = computed(() => {

  return store.state.caughtURL
})
</script>

<template class="view-error-page">
  <div class="view-error-page_error-message-container">
    <div><i class="fa-regular fa-triangle-exclamation" style="color: var(--info-icon-color);"></i>
      <span><strong style="color: #9b4242;"> Sorry, </strong> We can't find the page you are looking for</span>
      <div style="color: #131313; font-size: 14px; display: flex; justify-content: center;">{{getUrl}}</div>
      <div style="color: #73adba; font-size: 17px; margin: 10px 0 0 60px;">You may not have permission to view this page, or the url may be incorrect.</div>
      <div style="color: #131313; font-size: 14px; margin: 20px  0 0 200px">Press the back button or enter a new url.</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.view-error-page {

  &_error-message-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    width: 800px;
    margin: 100px auto;
    background: #fdfdfd;
    border-radius: 20px;
    font-size: 30px;
    color: var(--aqua-blue-definition);
  }

}
</style>
